export default "__VITE_ASSET__BtWm7Xoq__"